import { useEffect, useState } from "react";
import { GEO_GATING_CONFIG } from "../config/geoGating";
import { determineGeoDecision } from "../utils/geoDetection";
import { GeoLoadingScreen } from "./GeoLoadingScreen";
import { InfoView } from "./InfoView/InfoView";

type State = "checking" | "kva" | "info";

/**
 * Wettbewerbsschutz-Wrapper für die App.
 *
 * Beim ersten Render prüft er Geo + Sprach-Signale und entscheidet:
 * - "kva"  → Children rendern (normaler KVA)
 * - "info" → InfoView rendern (preislose Übersichts-Seite)
 *
 * Während der Prüfung läuft die GeoLoadingScreen (max ~2 Sek).
 * Bei Service-Ausfall: KVA (fail-open). `enabled: false` in der Config
 * überspringt die Prüfung komplett.
 */
export function GeoGate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<State>(GEO_GATING_CONFIG.enabled ? "checking" : "kva");

  useEffect(() => {
    if (!GEO_GATING_CONFIG.enabled) return;

    let cancelled = false;
    determineGeoDecision()
      .then(({ decision, signals }) => {
        if (cancelled) return;
        // Dezentes Logging — keine PII (kein IP, keine UA-Details).
        console.info(
          `[GeoGate] decision=${decision} country=${signals.country ?? "n/a"} lang=${signals.language ?? "n/a"} source=${signals.source}`
        );
        setState(decision);
      })
      .catch(() => {
        // determineGeoDecision sollte intern fail-open sein, aber zur Sicherheit.
        if (!cancelled) setState("kva");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") return <GeoLoadingScreen />;
  if (state === "info") return <InfoView />;
  return <>{children}</>;
}
